import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import classnames from "classnames";
import CardContent from "@material-ui/core/CardContent";
import Collapse from "@material-ui/core/Collapse";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRupeeSign } from "@fortawesome/free-solid-svg-icons";
import CloseIcon from "@material-ui/icons/CancelOutlined";
import CircularProgress from "@material-ui/core/CircularProgress";
import SavePDF from "@material-ui/icons/PictureAsPdf";
import Slide from "@material-ui/core/Slide";
import {
  primaryShade1,
  primaryShade3,
  grey,
  red,
  white,
  black
} from "../styles/color";
import moment from "moment";
import NoInvoicePrintDataDialog from "../components/NoInvoicePrintDataDialog";
const styles = theme => ({
  media: {
    height: 0,
    paddingTop: "56.25%" // 16:9
  },
  actions: {
    display: "flex"
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(0deg)"
  },
  avatar: {
    backgroundColor: red
  }
});
function Transition(props) {
  return <Slide direction="up" {...props} />;
}
class CompleteInvoice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      circularLaodingShow: false,
      pdfLoading: false,
      width: "210mm",
      height: "297mm",
      pdfIconColor: grey,
      customersList: [],
      pdfInvoiceDisplayDivHeight: "",
      openNoInvoicePrintDataDialog: false,
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ]
    };
  }
  handleInvoicePrintDataDialogOpen = () => {
    this.setState({ openNoInvoicePrintDataDialog: true });
  };
  handleInvoicePrintDataDialogClose = () => {
    this.setState({ openNoInvoicePrintDataDialog: false });
  };
  componentWillMount() {
    this.initializeData(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.initializeData(nextProps);
  }
  initializeData = whichProps => {
    this.setState({ circularLaodingShow: false });
    let deals = whichProps.allDeals;
    let customerId = this.props.match.params.customerId;
    let unPaidInvoices = whichProps.unPaidInvoices;
    let allInvoices = whichProps.allInvoices;
    const invoicedDealsId = [];
    let customersList = [];
    let tempCustomers = [];
    whichProps.unPaidInvoices.length > 0
      ? unPaidInvoices.map(dealsId =>
          dealsId.dealsId.map(data => invoicedDealsId.push(data))
        )
      : console.log("No Invoices Generated Yet");
    deals.map(deals => {
      if (invoicedDealsId.length > 0) {
        if (
          invoicedDealsId.find(invoiceDeals => deals.id.includes(invoiceDeals))
        ) {
          let a = deals;
          if (customerId === deals.buyerId) {
            a.customerName = deals.sellerName;
            a.customerId = deals.sellerId;
            a.customerBrokerage = deals.buyerBrokerage;
          }
          if (customerId === deals.sellerId) {
            a.customerName = deals.buyerName;
            a.customerId = deals.buyerId;
            a.customerBrokerage = deals.sellerBrokerage;
          }
          tempCustomers.push(a);
        }
      } else {
        console.log(" NO DATA TO SHOW ");
      }
      return tempCustomers;
    });
    customersList = [...new Set(tempCustomers)];
    this.setState({ customersList: tempCustomers });
    if (window.cordova) {
      this.setState({
        width: "100%",
        height: "100%",
        tableContentFontSize: "0.3em"
      });
    }
  };
  handleExpandClick = index => {
    this.setState(state => ({
      expanded: index === this.state.expanded ? false : index
    }));
  };
  handleCircularLoadingShow = index => {
    this.setState(state => ({
      circularLaodingShow:
        index === this.state.circularLaodingShow ? false : index
    }));
  };
  handleInvoicePrintDataRedirect = () => {
    this.props.history.push(`/addInvoicePrintData/${this.props.user.uid}`);
  };
  getDateValue = dateValue => {
    let recievedDateType = typeof dateValue;
    let currentDate =
      recievedDateType === "object"
        ? dateValue.toDate()
        : moment(dateValue).toDate();
    let date = currentDate.getDate();
    let month = this.state.months[currentDate.getMonth()];
    let year = currentDate
      .getYear()
      .toString()
      .substr(-2);
    let dateMonthYear = date + " " + month + " " + year;
    return dateMonthYear;
  };
  getDateValueNumber = dateValue => {
    let recievedDateType = typeof dateValue;
    let currentDate =
      recievedDateType === "object"
        ? dateValue.toDate()
        : moment(dateValue).toDate();
    let date = currentDate.getDate();
    let month = currentDate.getMonth() + 1;
    let year = currentDate.getFullYear();

    let dateMonthYear = date + "-" + month + "-" + year;
    return dateMonthYear;
  };
  render() {
    const {
      customersList,
      circularLaodingShow,
      openNoInvoicePrintDataDialog
    } = this.state;
    const {
      classes,
      unPaidInvoices,
      handleRemoveDeal,
      invoicePrintData,
      organisationId
    } = this.props;
    return (
      <div
        style={{
          height: "calc(100vh - 160px)",
          overflow: "scroll"
        }}
      >
        {unPaidInvoices.length > 0 ? (
          unPaidInvoices.map((data, index) => (
            <div
              style={{
                margin: "10px"
              }}
            >
              <Card>
                <CardContent
                  style={{ padding: "0px" }}
                  className={classnames(classes.expand, {
                    [classes.expandOpen]: this.state.expanded
                  })}
                  onClick={() => this.handleExpandClick(index)}
                  aria-expanded={this.state.expanded}
                  aria-label="View All"
                >
                  <div
                    style={{
                      display: "flex",
                      height: "50px",
                      backgroundColor: primaryShade1,
                      alignItems: "center",
                      justifyContent: "space-between",
                      color: white,
                      padding: "0px 7px 0px 7px"
                    }}
                  >
                    <span>
                      <strong style={{ color: black }}>BILL : </strong>
                      <strong>{data.invoiceNumber}</strong>
                    </span>
                    <span>
                      <strong>
                        {this.getDateValueNumber(data.invoiceDate)}
                      </strong>
                    </span>
                  </div>
                </CardContent>
                <Collapse
                  in={this.state.expanded === index}
                  timeout="auto"
                  unmountOnExit
                >
                  <CardContent id="content">
                    <div
                      style={{
                        height: "165px",
                        overflow: "scroll",
                        border: "0.2px solid black"
                      }}
                    >
                      {data.dealsId.map((singleDealId, index) =>
                        customersList.length ? (
                          customersList
                            .filter(row => row.id === singleDealId)
                            .map(row => (
                              <div id="oye">
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginBottom: "10px",
                                    marginTop: "10px",
                                    borderBottom: "1px solid grey",
                                    fontSize: "0.8em",
                                    width: "100%"
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "right",
                                      width: "20%",
                                      alignItem: "center"
                                    }}
                                  >
                                    <span>{this.getDateValue(row.date)}</span>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      width: "50%",
                                      color: grey[500]
                                    }}
                                  >
                                    <span>
                                      {row.quantity} TON / {row.customerName}
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "right",
                                      width: "20%"
                                    }}
                                  >
                                    <span>
                                      <FontAwesomeIcon
                                        icon={faRupeeSign}
                                        size={".40x"}
                                      />
                                      {parseInt(row.rate) *
                                        parseInt(row.quantity)}
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "right",
                                      width: "05%",
                                      color: grey[500]
                                    }}
                                  >
                                    <span>
                                      <CloseIcon
                                        style={{ fontSize: 15 }}
                                        onClick={e => {
                                          e.preventDefault();
                                          this.handleCircularLoadingShow(index);
                                          handleRemoveDeal(
                                            row.id,
                                            data.id,
                                            row.customerId,
                                            this.props.match.params.customerId
                                          );
                                        }}
                                      />
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "right",
                                      width: "05%",
                                      color: primaryShade1
                                    }}
                                  >
                                    <span>
                                      {circularLaodingShow === index ? (
                                        <CircularProgress size={15} />
                                      ) : null}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ))
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              height: "40px",
                              justifyContent: "space-around",
                              alignItems: "center"
                            }}
                          >
                            <h3>
                              Invoice details are being fetched please wait...
                            </h3>
                          </div>
                        )
                      )}
                    </div>

                    <div id="cardContent">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginTop: "7px",
                          padding: "7px",
                          alignItems: "center",
                          fontSize: "0.8em",
                          borderBottom: "1px solid grey"
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-around",
                            alignItems: "center",
                            backgroundColor: primaryShade3,
                            borderRadius: "10px",
                            minWidth: "110px",
                            padding: "0px 5px"
                          }}
                        >
                          <span>DEALS</span>
                          <hr style={{ height: "20px" }} />
                          <span>{parseInt(data.dealsTotalQuantity)} TON</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-around",
                            alignItems: "center",
                            backgroundColor: primaryShade3,
                            borderRadius: "10px",
                            minWidth: "110px",
                            padding: "0px 5px"
                          }}
                        >
                          <span>BROKERAGE</span>
                          <hr style={{ height: "20px" }} />{" "}
                          <span>&#8377; {parseInt(data.invoiceAmount)}</span>
                          <span />
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          marginTop: "10px",
                          justifyContent: "space-around",
                          marginBottom: "15px",
                          width: "100%"
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-evenly",
                            alignItems: "center",
                            width: "100%"
                          }}
                        >
                          <Button
                            variant="contained"
                            onClick={e => {
                              e.preventDefault();
                              this.props.updateInvoice(
                                data.id,
                                data.dealsId,
                                data.customerId
                              );
                            }}
                            style={{
                              borderRadius: "12px",
                              backgroundColor: primaryShade1
                            }}
                          >
                            <span style={{ color: white }}>MARK PAID</span>
                          </Button>
                          <Button
                            variant="contained"
                            size="small"
                            onClick={e => {
                              e.preventDefault();
                              if (invoicePrintData === undefined) {
                                this.handleInvoicePrintDataDialogOpen();
                              } else {
                                this.props.history.push(
                                  `/invoice/${this.props.match.params.customerId}/showPdfInvoice/${data.id}`
                                );
                              }
                            }}
                          >
                            <SavePDF
                              style={{ color: primaryShade1 }}
                              width={"40px"}
                              height={"40px"}
                            />
                            Invoice
                          </Button>
                        </div>
                        <NoInvoicePrintDataDialog
                          openNoInvoicePrintDataDialog={
                            openNoInvoicePrintDataDialog
                          }
                          handleInvoicePrintDataDialogClose={
                            this.handleInvoicePrintDataDialogClose
                          }
                          handleInvoicePrintDataRedirect={
                            this.handleInvoicePrintDataRedirect
                          }
                        />
                      </div>
                    </div>
                  </CardContent>
                </Collapse>
              </Card>
              <br />
            </div>
          ))
        ) : (
          <div
            style={{
              display: "flex",
              height: "calc(100vh - 160px)",
              justifyContent: "space-around",
              alignItems: "center"
            }}
          >
            <h3>No Invoices To Show Create One First....</h3>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(CompleteInvoice));
